<template>
    <dashboard-layout>
        <form @submit.prevent="create">
            <div class="container-fluid">
                <div class="d-md-flex justify-content-between align-items-center mb-1">
                    <h3 class="mb-0">Question bank</h3>
                </div>

                <blockquote class="blockquote mt-3 p-3">
                    <p class="text-muted mb-0 fst-italic">
                        Welcome to the main question bank.
                        <br>
                        You've answered {{ form_options.total_answer }} questions with an average score of {{ form_options.average_answer_score }}%.
                    </p>
                </blockquote>

                <div class="row">
                    <div class="col-lg-8 mt-4">
                        <div class="card border-0 shadow rounded p-4 mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <h6 class="mb-0">Content</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4">
                                <div v-for="subject in form_options?.subjects" :key="subject.id" class="border rounded mb-1 card">
                                    <div class="card-header p-1 bg-transparent border-bottom">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" :id="'subjects-' + subject.id"
                                                   :value="subject.id" v-model="item.subjects" @change="updateSections(subject.id)">
                                            <label class="form-check-label" :for="'subjects-' + subject.id">{{ subject.name }}</label>
                                        </div>
                                    </div>

                                    <div v-if="item.subjects.includes(subject.id)" v-for="section in subject?.sections" :key="section.id" class="ms-2 p-1">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" :id="'sections-' + section.id"
                                                   :value="section.id" v-model="item.sections" @change="updateCategories(section.id)">
                                            <label class="form-check-label" :for="'sections-' + section.id">{{ section.name }}</label>
                                        </div>

                                        <div v-if="item.sections.includes(section.id)" class="ms-2">
                                            <div class="form-check form-switch" v-for="option in section?.categories" :key="option.id">
                                                <input class="form-check-input" type="checkbox" :id="'categories-' + option.id"
                                                       :value="option.id" v-model="item.categories">
                                                <label class="form-check-label" :for="'categories-' + option.id">{{ option.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card border-0 shadow rounded p-4 mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <h6 class="mb-0">Universities</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 px-2">
                                <div class="form-check form-switch" v-for="option in form_options?.universities" :key="option.id">
                                    <input class="form-check-input" type="checkbox" :id="'universities-' + option.id"
                                           :value="option.id" v-model="item.universities">
                                    <label class="form-check-label" :for="'universities-' + option.id">{{ option.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="card border-0 shadow rounded p-4 mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <h6 class="mb-0">Year</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 px-2">
                                <div class="row g-3 align-items-center">
                                    <div class="col-auto">
                                        from
                                    </div>
                                    <div class="col-auto">
                                        <input type="number" id="yearFrom" v-model="item.years.from" class="form-control" placeholder="" min="2000">
                                    </div>
                                    <div class="col-auto">
                                        to
                                    </div>
                                    <div class="col-auto">
                                        <input type="number" id="yearTo" v-model="item.years.to" class="form-control" placeholder="" min="2000">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card border-0 shadow rounded p-4 mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <h6 class="mb-0">Number of questions</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 px-2">
                                <input type="number" id="yearFrom" v-model="item.questions_number" class="form-control" placeholder="" min="1" >
                            </div>
                        </div>
                        <div class="card border-0 shadow rounded p-4 mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <div class="flex-1">
                                        <h6 class="mb-0">question selection</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 px-2">
                                <select class="form-select" v-model="item.question_selection">
<!--                                    <option value="new">Show me new questions only</option>-->
<!--                                    <option value="incorrect">Repeat questions marked incorrect</option>-->
                                    <option value="new">New questions only</option>
<!--                                    <option value="incorrect">New questions only ( Allowing wrong questions ) </option>-->
                                    <option value="only_correct">Correct Questions</option>
                                    <option value="only_incorrect">In Correct Questions</option>
                                </select>
                            </div>
                        </div>

                        <div class="card border-0 shadow rounded p-4 mb-3">
                            <div class="post-meta d-flex justify-content-between">
                                <ul class="list-unstyled mb-0">
                                    <li class="list-inline-item me-2">
                                        <button type="submit" id="submit" name="send" class="btn btn-primary" :disabled="questions_count < 1">
                                            Start new session
                                        </button>
                                    </li>
                                    <li class="list-inline-item">
                                        <a href="javascript:void(0)" class="text-muted like">
                                            <i class="ti ti-help me-1"></i>
                                            {{ questions_count }} questions found</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 mt-4">
                        <div class="table-responsive bg-white shadow rounded ">
                            <table class="table mb-0 table-center">
                                <thead>
                                <tr>
                                    <th scope="col" class="fw-normal border-bottom text-muted py-4 px-3" colspan="2">Recent sessions</th>

                                </tr>
                                </thead>
                                <tbody>
                                <tr  v-for="session in sessions?.data" :key="session.id">
                                    <th class="p-3">
                                        <div class="align-items-center">
                                            <i class="uil uil-notes h6"></i>
                                            <p class="mb-0 d-inline fw-normal h6 ms-1">
                                                <router-link
                                                    :to="{name: 'question_sessions.show', params: { session_id: session.id }}"
                                                    class="mb-0 text-muted">
                                                    <span v-for="subject in session?.subjects" class="me-1">
                                                        {{ subject.name }}
                                                    </span>
                                                    <span v-for="universitie in session?.universities" class="me-1">
                                                        {{ universitie.name }}
                                                    </span>
                                                </router-link>

                                            </p>
                                        </div>
                                    </th>
                                    <td class="p-3 text-end">
                                        <router-link
                                            :to="{name: 'question_sessions.show', params: { session_id: session.id }}">

                                            <span class="badge bg-soft-primary">Continue</span>
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

<!--                        <div class="card border-0 rounded shadow p-4 mb-3">-->
<!--                            <div class="d-flex justify-content-between align-items-center">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                    <div class="flex-1 ms-2">-->
<!--                                        <h6 class="mb-0">Recent sessions</h6>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="d-flex justify-content-between align-items-center" v-for="session in items?.data" :key="session.id">-->

<!--                                <router-link :to="{name: 'question_sessions.show', params: { session_id: session.id }}" class="d-flex align-items-center mt-4">-->
<!--&lt;!&ndash;                                    <img src="assets/images/client/06.jpg" class="avatar avatar-md-sm rounded-circle border shadow" alt="">&ndash;&gt;-->
<!--                                    <div class="flex-1 ms-2">-->
<!--                                        <h6 class="mb-0 text-dark">-->
<!--                                            <span v-for="subject in session?.subjects" class="me-1">-->
<!--                                                {{ subject.name }}-->
<!--                                            </span>-->
<!--                                            <span v-for="universitie in session?.universities" class="me-1">-->
<!--                                                {{ universitie.name }}-->
<!--                                            </span>-->
<!--                                        </h6>-->
<!--                                        <small class="text-muted">-->
<!--                                            {{ session.ago }}-->
<!--                                        </small>-->
<!--                                    </div>-->
<!--                                </router-link>-->

<!--                                <a href="profile.html" class="text-primary"><i class="ti ti-arrow-right"></i></a>-->
<!--                            </div>-->

<!--&lt;!&ndash;                            <Bootstrap5Pagination&ndash;&gt;-->
<!--&lt;!&ndash;                                class="mb-0"&ndash;&gt;-->
<!--&lt;!&ndash;                                :data="items"&ndash;&gt;-->
<!--&lt;!&ndash;                                :limit="2"&ndash;&gt;-->
<!--&lt;!&ndash;                                :show-disabled="false"&ndash;&gt;-->
<!--&lt;!&ndash;                                :size="'default'"&ndash;&gt;-->
<!--&lt;!&ndash;                                :align="'center'"&ndash;&gt;-->
<!--&lt;!&ndash;                                @pagination-change-page="getResults"&ndash;&gt;-->
<!--&lt;!&ndash;                            />&ndash;&gt;-->


<!--                        </div>-->
                    </div>
                </div>
            </div>
        </form>
    </dashboard-layout>
</template>



<script>
import { useToast } from "vue-toastification";
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();
import Utility from "../utility";

export default {
    components: { DashboardLayout },
    data() {
        return {
            form_options: {},
            sessions: [],
            item: {
                categories: [],
                sections: [],
                subjects: [],
                universities: [],
                years: {
                    from: null,
                    to: null
                },
                questions_number: null,
                question_selection: 'new'
            },
            questions_count: 0,
        };
    },
    created() {

        this.getResults();
        this.getFilter();

    },
    watch: {
        'item':{
            handler: function (val) {
                this.getCount();
            },
            deep: true
        }
    },
    methods: {
        updateSections(subjectId) {
            const subject = this.form_options.subjects.find(s => s.id === subjectId);
            if (!this.item.subjects.includes(subjectId)) {
                if (subject && subject.sections) {
                    subject.sections.forEach(section => {
                        this.item.sections = this.item.sections.filter(id => id !== section.id);
                        if (section.categories) {
                            section.categories.forEach(category => {
                                this.item.categories = this.item.categories.filter(id => id !== category.id);
                            });
                        }
                    });
                }
            }
        },
        updateCategories(sectionId) {
            const subject = this.form_options.subjects.find(s => s.sections.some(sec => sec.id === sectionId));
            if (!this.item.sections.includes(sectionId)) {
                if (subject) {
                    const section = subject.sections.find(sec => sec.id === sectionId);
                    if (section && section.categories) {
                        section.categories.forEach(category => {
                            this.item.categories = this.item.categories.filter(id => id !== category.id);
                        });
                    }
                }
            }
        },
        getResults ( page = this.$route?.query?.page ?? 1 ) {

            const id = toast.info('Getting content ...', { icon: 'fa-solid fa-download' });

            axios.get('question_sessions', { params : { 'subscribe_id' : this.$route?.params?.subscribe_id }} ).then(response => {
                toast.dismiss(id);
                this.sessions = response.data;
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
        getFilter ( ) {

            const id = toast.info('getting options ...', { icon: 'fa-light fa-filter-list' });

            axios.get('question_sessions/filter',{
                params: {
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                toast.dismiss(id);
                this.form_options = response.data.elements;
                this.questions_count = response.data.elements?.total_questions ?? 0;
            }).catch(error => {
                toast.dismiss(id);
                if (error.response) {
                    this.validationErrors = error.response.data.errors;
                }
            });
        },
        getData ( ) {
            let formData = Utility.convertModelToFormData(this.item);
            // formData.append('course_id', this.$route.params.id);
            formData.append('subscribe_id', this.$route?.params?.subscribe_id);

            return formData;
        },
        getCount ( ) {

            const that = this;

            axios.post('question_sessions/count',
                this.getData ( )
            ).then(response => {
                that.questions_count = response.data?.data?.count ?? 0;
            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    that.error_message = error.response.data.message ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        },
        create() {

            const id = toast.info('creating ...',{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;
            this.error_message = null;


            axios.post('question_sessions',
                this.getData ( )
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.item = {};
                this.$router.push({name: 'question_sessions.show', params: {session_id: response.data.data.id} });

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    that.error_message = error.response.data.message ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        },
    }
}
</script>
